import React, { useContext } from "react";
import { useInvitation } from "../../../../Context/Invitation/InvitationContext";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import UserDisplay from "../../../Shared/User/UserDisplay";
import { TOGGLE_SHOW_REJECT_INVITATION_DIALOG, TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG, SET_SELECTED_PROJECT_ID } from "../InvitationEvents";
import { statusHelper } from "../../TenantManagement/utils";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../Renderers/GlobalContext";

// ✅ Status Cell Component 
const StatusCell = ({ dataItem }) => {

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const status = statusHelper.find(status => status.key === dataItem.status.toLowerCase()) || statusHelper.find(status => status.key === "notfound");

    const statusText = t(status.key);

    return (
        <td title={status.value}>
            <span className={`text-${status.color}`}>
                <i className={status.icon}></i>
                <span className="ms-2">{statusText}</span>
            </span>
        </td>
    );
};

// create ActionCell Component having 2 buttons to accept and reject invitation
const ActionCell = (props) => {

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })
    const { dispatch } = useInvitation();
    const { organization } = useContext(GlobalContext).state
    const { status, tenantProject, enableTenantTestEnvironment } = props.dataItem;

    const handleReject = () => {
        dispatch({ type: SET_SELECTED_PROJECT_ID, payload: props.dataItem.masterProjectId });
        dispatch({ type: TOGGLE_SHOW_REJECT_INVITATION_DIALOG });
    }

    const handleAccept = () => {
        dispatch({ type: SET_SELECTED_PROJECT_ID, payload: props.dataItem.masterProjectId });
        dispatch({ type: TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG });
    }

    const handleGoToApp = (e) => {
        e.preventDefault();
        const instance = tenantProject.instances.find(instance => instance.instanceType === "Production");
        if (!instance) {
            return;
        }
        const tenantUrl = tenantProject.name + "_" + instance._id.substring(0, 5);
        const url = process.env.REACT_APP_RUNTIME_URL + "/" + organization.orgUrl + "/" + tenantUrl;
        window.open(url, "_blank");
    }

    const handleGoToAppTest = (e) => {
        e.preventDefault();
        const instance = tenantProject.instances.find(instance => instance.instanceType === "Test");
        if (!instance) {
            return;
        }
        const tenantUrl = tenantProject.name + "_" + instance._id.substring(0, 5);
        const url = process.env.REACT_APP_RUNTIME_URL + "/" + organization.orgUrl + "/" + tenantUrl;
        window.open(url, "_blank");
    }

    return (
        <td className="text-end">
            {status === "accepted" &&
                <>
                    <button
                        onClick={handleGoToApp}
                        className="btn btn-primary btn-sm">
                        <i className="fas fa-external-link-alt me-1"></i>
                        {t("go_to_app_button")}
                    </button>
                    {enableTenantTestEnvironment &&
                        <button
                            onClick={handleGoToAppTest}
                            className="btn btn-primary btn-sm ms-2">
                            <i className="fas fa-external-link-alt me-1"></i>
                            {t("go_to_app_button_test")}
                        </button>
                    }
                </>
            }
            {status === "invited" && (
                <>
                    <button className="btn btn-success" onClick={handleAccept}>
                        <i className="fas fa-check me-2"></i>
                        {t("accept_button")}
                    </button>
                    <button className="btn btn-danger ms-2" onClick={handleReject}>
                        <i className="fas fa-times me-2"></i>
                        {t("reject_button")}
                    </button>
                </>
            )}
        </td>
    );
}

const InvitationGrid = () => {
    const { state } = useInvitation();
    const invitedByUser = state.invitations.invitedByUser || {};

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    return (
        <Grid
            data={state.invitations.masterProjects}
            style={{ height: "100%" }}
        >
            <GridNoRecords>
                <small className="text-muted text-center">
                    {t("no_invitations_found")}
                </small>
            </GridNoRecords>
            <Column
                width={40}
                title="#"
                cell={({ dataIndex }) => (
                    <td>{dataIndex + 1}</td>
                )}
            />
            <Column
                title={t("invited_by")}
                cell={({ dataItem }) =>
                    <td>
                        <UserDisplay
                            bgColor={invitedByUser.bgColor || "#000"}
                            email={invitedByUser.email}
                            firstName={invitedByUser.firstName || ""}
                            lastName={invitedByUser.lastName || ""}
                            displayName={invitedByUser.displayName || ""}
                            showEmail={invitedByUser.email ? true : false}
                        />
                    </td>
                }
            />
            <Column
                field="status"
                title={t("status")}
                cell={StatusCell}
            />
            <Column
                title={t("app")}
                cell={({ dataItem }) =>
                    <td>
                        {dataItem.masterProject?.name}
                    </td>
                }
            />
            <Column
                width={80}
                title={t("Environment")}
                cell={({ dataItem }) => {
                    const environment = dataItem.masterProject?.instances.find(instance => instance._id === dataItem.masterAppId);
                    return (
                        <td title={environment?.instanceName || ""}>
                            {environment?.instanceName || ""}
                        </td>
                    );
                }}
            />
            <Column cell={ActionCell} />
        </Grid>
    );
}

export default InvitationGrid;
